import { message } from 'antd'
import { Model } from 'dva'

const undoStackSize = 100
const redoStackSize = 100

const FlowBuilder: Model = {
  namespace: 'flowBuilder',
  state: {
    undoStack: [],
    redoStack: [],
  },
  effects: {
    *undo({ payload }, { put, select }) {
      const undoStack = yield select((state: any) => state.flowBuilder.undoStack)
      if (undoStack.length === 0) {
        message.error(`Nothing to undo!`)
        return
      }
      const undoElement = undoStack[undoStack.length - 1]
      yield put({ type: 'popUndo' })
      if (!payload || !payload.undoHelpers) {
        if (process.env.NODE_ENV === 'development') {
          message.error('undoHelpers is undefined in the payload')
        }
        throw 'undoHelpers is undefined in the payload'
      }
      console.info('Performing Undo: ', undoElement?.type, undoElement.data)
      payload.undoHelpers(undoElement?.type, undoElement.data)
      yield put({ type: 'addRedo', payload: undoElement })
      if (undoElement?.type === 'block-position-change') {
        let undoStack = yield select((state: any) => state.flowBuilder.undoStack)
        let undoElement = undoStack[undoStack.length - 1]
        while (
          undoElement?.type === 'path-position-change' &&
          undoElement?.data?.source_block === undoElement?.data?.id &&
          undoElement?.data?.destination_block === undoElement?.data?.id
        ) {
          yield put({ type: 'popUndo' })
          undoStack = yield select((state: any) => state.flowBuilder.undoStack)
          undoElement = undoStack[undoStack.length - 1]
        }
      }
    },
    *redo({ payload }, { put, select }) {
      const redoStack = yield select((state: any) => state.flowBuilder.redoStack)
      if (redoStack.length === 0) {
        message.error(`Nothing to redo!`)
        return
      }
      const redoElement = redoStack[redoStack.length - 1]
      yield put({ type: 'popRedo' })
      if (!payload || !payload.redoHelpers) {
        if (process.env.NODE_ENV === 'development') {
          message.error('redoHelpers is undefined in the payload')
        }
        throw 'redoHelpers is undefined in the payload'
      }
      console.info('Performing Redo: ', redoElement?.type, redoElement.data)
      payload.redoHelpers(redoElement?.type, redoElement.data)
      yield put({ type: 'addUndo', payload: redoElement })
    },
  },
  reducers: {
    handleUndoRedo(state, action) {
      if (!action.payload) {
        if (process.env.NODE_ENV === 'development') {
          message.error('Undo/Redo payload is undefined')
        }
        throw 'Undo/Redo payload is undefined'
      }
      const { type, data } = action.payload
      const stack = state.undoStack
      if (state.undoStack.length === 0) {
        localStorage.setItem('flow_url', window.location.pathname)
      }
      stack.push({
        type,
        data,
      })
      console.info('handleUndoRedo:', type, data)
      return {
        ...state,
        undoStack: stack,
      }
    },
    addRedo(state, action) {
      const redoStack = state.redoStack
      if (!action.payload) {
        if (process.env.NODE_ENV === 'development') {
          message.error('Cannot add in redo stack, undefined payload')
        }
        throw 'Cannot add in redo stack, undefined payload'
      }
      redoStack.push(action.payload)
      return {
        ...state,
        redoStack: [...redoStack],
      }
    },
    popRedo(state) {
      const redoStack = state.redoStack
      if (redoStack?.length == 0) return null
      redoStack.pop()
      return {
        ...state,
        redoStack: [...redoStack],
      }
    },
    addUndo(state, action) {
      const undoStack = state.undoStack
      if (!action.payload) {
        if (process.env.NODE_ENV === 'development') {
          message.error('Cannot add in undo stack, undefined payload')
        }
        throw 'Cannot add in undo stack, undefined payload'
      }
      undoStack.push(action.payload)
      return {
        ...state,
        undoStack: [...undoStack],
      }
    },
    popUndo(state) {
      const undoStack = state.undoStack
      if (undoStack?.length == 0) return null
      undoStack.pop()
      return {
        ...state,
        undoStack: [...undoStack],
      }
    },
    changeSubFlowID(state, action) {
      const undoStack = state.undoStack
      if (undoStack?.length == 0) return null
      if (undoStack[undoStack.length - 1]?.type == 'convert-subflow') {
        const subflowObj = undoStack[undoStack.length - 1]
        subflowObj.data.new_subflow_id = action.payload.new_id
        undoStack.pop()
        return {
          ...state,
          undoStack: [...undoStack, subflowObj],
        }
      }
      return {
        ...state,
      }
    },
    clearUndoRedo(state) {
      return {
        ...state,
        redoStack: [],
        undoStack: [],
      }
    },
  },
}

export default FlowBuilder
